var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"snow-container"}},_vm._l((_vm.snowflakes),function(snowflake){return _c('div',{key:snowflake.id,class:snowflake.class,style:(snowflake.style)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }